import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description?: string;
  image?: string;
  type?: "website" | "article" | "profile";
  pathname?: string;
}

const SITE_URL = "https://sportrank.vn";
const DEFAULT_IMAGE = `${SITE_URL}/pwa-512x512.png`;

/**
 * Per-route SEO/social preview tags. Overrides the static head in index.html
 * for JS-executing crawlers (Googlebot). Social crawlers (Facebook/Zalo/etc.)
 * that don't execute JS still see the static fallback in index.html, plus the
 * dedicated `match-og` edge function for /matches/:id deep links.
 */
export function SEO({ title, description, image, type = "website", pathname }: SEOProps) {
  const url = pathname
    ? `${SITE_URL}${pathname.startsWith("/") ? pathname : `/${pathname}`}`
    : typeof window !== "undefined"
      ? `${SITE_URL}${window.location.pathname}`
      : SITE_URL;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
